class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    // Blair 2026-07-09: play a close animation for the SEARCH modal before it
    // actually closes (the search panel fades + slides up instead of vanishing).
    const isSearch = this.classList.contains('header__search');
    const panel = this.querySelector('.search-modal');
    if (isSearch && panel && this.detailsContainer.hasAttribute('open') && !this._blairClosing) {
      this._blairClosing = true;
      this.classList.add('is-closing');
      const finish = () => {
        clearTimeout(fallback);
        panel.removeEventListener('animationend', finish);
        this._blairClosing = false;
        this.classList.remove('is-closing');
        this.detailsContainer.removeAttribute('open');
      };
      const fallback = setTimeout(finish, 400);
      panel.addEventListener('animationend', finish, { once: true });
      return;
    }

    this.detailsContainer.removeAttribute('open');
  }
}

customElements.define('details-modal', DetailsModal);
